Handlebars.registerHelper('limit', function(arr, limit) {
    if (Object.prototype.toString.call(arr) !== '[object Array]' ) {
        return [];
    }

    return arr.slice(0, limit);
});

Handlebars.registerHelper('hasStock', function(lvalue, options) {
    for (let variant of lvalue) {
        if (variant.available) {
            return options.fn(this);
        }
    }

    return options.inverse(this);
});

Handlebars.registerHelper('showSizes', function(lvalue, options) {
    let product_options = lvalue.options;
    let sizes = [];
    for (let x in product_options) {
        let o = product_options[x]
        if (o.name == 'Size')
            sizes = o.values
    }

    for (let i in lvalue.variants) {
        let variant = lvalue.variants[i]
        if (!variant.available) {
            let option1 = variant.option1
            let option2 = variant.option2
            let option3 = variant.option3

            var index = sizes.indexOf(option1);
            if (index !== -1) 
                sizes.splice(index, 1); 
            index = sizes.indexOf(option2);
            if (index !== -1) 
                sizes.splice(index, 1);
        }
    }
    return sizes.join(" ")
})

Handlebars.registerHelper('unlessHasOnlyDefaultVariant', function(product, options) {
    if (product.variants.length === 1 || product.tags.indexOf('variant-select') !== -1 || product.tags.indexOf('arriving soon') !== -1) {
        return options.inverse(this);
    }

    return options.fn(this);
});

Handlebars.registerHelper('hasAtLeastOneVariant', function(lvalue, options) {
    for (let variant of lvalue) {
        if ((variant.title !== '') && (variant.title !== 'Default Title')) {
            return options.fn(this);
        }
    }

    return options.inverse(this);
});

Handlebars.registerHelper('hasAtLeastOneVariantUnavailable', function(lvalue, options) {
    for(let variants of lvalue) {
        if(!variants.available) {
            return options.fn(this);
        }
    }
    return options.inverse(this);
});

Handlebars.registerHelper('imageLink', function(link, options) {
    let density = '';
    if ((window.devicePixelRatio || 1) > 1) {
        density = '@2x';
    }

    if (link) {
        if (link.src) {
            return Shopify.resizeImage(link.src, options.hash.size + density);
        } else {
            return Shopify.resizeImage(link, options.hash.size + density);
        }
    }
});

Handlebars.registerHelper('times', function(n, block) {
    var accum;
    for(var i = 0; i < n.length; ++i) {
        block.data.day = n[i];
        if (accum)
            accum += block.fn(this);
        else
            accum = block.fn(this);
    }
    return accum;
});

Handlebars.registerHelper('products_per_row', function(n) {
    return window.products_per_row;
});

Handlebars.registerHelper('underlined', function(n) {
    if (window.product_underline) return 'underline'
});

Handlebars.registerHelper('uppercase', function(n) {
    if (window.product_uppercase) return 'uppercase'
});

Handlebars.registerHelper('registerProductVariants', function(variants, product) {
    var options = [];
    for (var i = 0; i < product.options.length; i ++) {
        options.push(product.options[i]['name'])
    }
    if (variants.length > 0) {
        products[product.id+'-options'] = options
    }
    products[product.id] = variants;
    return ''
});

Handlebars.registerHelper('imageLink', function (link, options) {
    if (!link) {
        return '';
    }

    if (link.src) {
        return slate.Image.getSizedImageUrl(link.src, options.hash.size);
    } else {
        return slate.Image.getSizedImageUrl(link, options.hash.size);
    }
});

Handlebars.registerHelper('moneyFormat', function(price) {
    if (price % 1 > 0)
        price = parseInt(price);
    let n = Shopify.formatMoney(price, Shopify.money_without_trailing_zeros);
    return new Handlebars.SafeString(n);
});

Handlebars.registerHelper('moneyFormatNoCurrency', function (money) {
    var formatted = slate.Currency.formatMoney(money, theme.moneyFormat);
    return new Handlebars.SafeString(formatted);
});

Handlebars.registerHelper('showVariant', function (item, options) {
    // return item;
    return '';
});

Handlebars.registerHelper('showOptions', function (item, iOptions) {
    let options = item.options_with_values;
    let option_html = ''
    for (let i = 0; i < options.length; i ++) {
        let option = options[i]
        let value = option.value
        option_html += `<div>${value}</div>`
    }
    return new Handlebars.SafeString(option_html)
});

Handlebars.registerHelper('showBadge', function(item, iOptions) {
    let available = false;
    let onSale = false;
    let badge = ''

    for (let i = 0; i < item.variants.length; i ++) {
        let variant = item.variants[i];
        if (variant.available) {
            available = true;
        }
        if (variant.compare_at_price) {
            if (parseFloat(variant.compare_at_price) > parseFloat(variant.price))
                onSale = true;
        }
    }

    if (available) {
        if (onSale) {
            badge = '<div class="badge sale is-size-3">on sale</div>';
        }
    } else {
        badge = '<div class="badge sold-out is-size-3">Sold out</div>';
    }
    return new Handlebars.SafeString(badge);
})

Handlebars.registerHelper('showOriginalPrice', function (price, originalPrice, options) {
    if (price !== originalPrice) {
        return options.fn(this);
    }

    return options.inverse(this);
});

Handlebars.registerHelper('showDiscountMessage', function (discounts, options) {
    if (discounts && discounts.length > 0) {
        return options.fn(this);
    }

    return options.inverse(this);
});

Handlebars.registerHelper('compare', function(lvalue, rvalue, options) {

	if (arguments.length < 3)
	    throw new Error("Handlerbars Helper 'compare' needs 2 parameters");

	operator = options.hash.operator || "==";

	var operators = {
	    '==':       function(l,r) { return l == r; },
	    '===':      function(l,r) { return l === r; },
	    '!=':       function(l,r) { return l != r; },
	    '<':        function(l,r) { return l < r; },
	    '>':        function(l,r) { return l > r; },
	    '<=':       function(l,r) { return l <= r; },
	    '>=':       function(l,r) { return l >= r; },
	    'typeof':   function(l,r) { return typeof l == r; }
	}

	if (!operators[operator])
	    throw new Error("Handlerbars Helper 'compare' doesn't know the operator "+operator);

	var result = operators[operator](lvalue,rvalue);

	if( result ) {
	    return options.fn(this);
	} else {
	    return options.inverse(this);
	}
});



